var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashTurnOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49146 17.063C7.34146 17.063 7.22146 17.033 7.13146 16.9955C6.83146 16.883 6.32146 16.5155 6.32146 15.353V10.5155H4.56646C3.56146 10.5155 3.20146 10.043 3.07396 9.76546C2.94646 9.48046 2.83396 8.90296 3.49396 8.14546L9.17146 1.69546C9.93646 0.825463 10.559 0.885463 10.859 0.997963C11.159 1.11046 11.669 1.47796 11.669 2.64046V7.47796H13.424C14.429 7.47796 14.789 7.95046 14.9165 8.22796C15.044 8.51296 15.1565 9.09046 14.4965 9.84796L8.81896 16.298C8.28646 16.9055 7.82146 17.063 7.49146 17.063ZM10.4465 2.05546C10.424 2.08546 10.2665 2.16046 10.019 2.44546L4.34146 8.89546C4.13146 9.13546 4.10146 9.28546 4.10146 9.31546C4.11646 9.32296 4.25146 9.39796 4.56646 9.39796H6.88396C7.19146 9.39796 7.44646 9.65296 7.44646 9.96046V15.3605C7.44646 15.7355 7.51396 15.9005 7.54396 15.9455C7.56646 15.9155 7.72396 15.8405 7.97146 15.5555L13.649 9.10546C13.859 8.86546 13.889 8.71546 13.889 8.68546C13.874 8.67796 13.739 8.60296 13.424 8.60296H11.1065C10.799 8.60296 10.544 8.34796 10.544 8.04046V2.64046C10.5515 2.26546 10.4765 2.10796 10.4465 2.05546Z",
    fill: "#05070F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashTurnOn);
export default __webpack_public_path__ + "static/media/flash_turn_on.b31a3a387a432e61347ea18200443edb.svg";
export { ForwardRef as ReactComponent };